var exports = {
  "zr": "xe533113f--b99cfc--root",
  "O0": "xe533113f--b99cfc--rating",
  "oV": "xe533113f--b99cfc--reviews-count",
  "Om": "xe533113f--b99cfc--dot",
};

module.exports = exports;
